import i18n from '@service/I18nService';
import { $api } from '@service/RequestService';
import { useMutation } from 'react-query';

import { IQuery } from 'modules/event-list/models';

export function useDownloadLogsExcel(props: IQuery) {
  return useMutation(async () => {
    const res = await $api.post(
      `/v1/activity-logs/filter/excel?lang=${i18n.language?.toUpperCase()}`,
      { ...props, startDate: props?.startDate?.slice(0, 10), finishDate: props?.finishDate?.slice(0, 10) },
      {
        responseType: 'blob'
      }
    );

    return res.data;
  });
}
